module.exports = __webpack_public_path__ + "img/logo.8fc245d8.png";